import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      nav("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <section className="min-h-[70vh] flex items-center justify-center section-py">
      <div className="w-full max-w-md rounded-3xl bg-white border border-[#0A2540]/10 p-8 md:p-10">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#D4AF37]">
          <Lock className="w-4 h-4" /> Admin Login
        </div>
        <h1 className="mt-3 font-serif-display text-3xl text-[#0A2540]">
          Foundation Admin
        </h1>
        <p className="mt-2 text-sm text-[#4A5568]">
          Access donations, CSR enquiries and receipt logs.
        </p>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-4">
          <div>
            <Label>Email</Label>
            <Input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="mt-2 h-11"
              autoComplete="username"
            />
          </div>
          <div>
            <Label>Password</Label>
            <Input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="mt-2 h-11"
              autoComplete="current-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full rounded-full bg-[#0A2540] text-white hover:bg-[#D4AF37] hover:text-[#0A2540] px-8 py-6 text-base font-medium"
          >
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
    </section>
  );
}
